import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { usePreviewAwareAuth } from "@/contexts/SuperAdminPreviewContext";

/**
 * Detects if the current chef_rayon is a "GT" (Groupe de Travail)
 * on a centrale's technical HQ store.
 * Returns { isCentraleGT, centraleId, isLoading }
 */
export function useIsCentraleGT() {
  const { userRole, userProfile } = usePreviewAwareAuth();
  const storeId = userProfile?.store_id;
  const isChefRayon = userRole === "chef_rayon";

  const { data, isLoading } = useQuery({
    queryKey: ["is-centrale-gt", storeId],
    enabled: isChefRayon && !!storeId,
    staleTime: 1000 * 60 * 30, // 30 min cache
    queryFn: async () => {
      const { data: store, error } = await supabase
        .from("stores")
        .select("is_centrale_hq, centrale_id")
        .eq("id", storeId!)
        .maybeSingle();
      if (error || !store) return { isCentraleHQ: false, centraleId: null };
      return {
        isCentraleHQ: !!(store as any).is_centrale_hq,
        centraleId: (store as any).centrale_id as string | null,
      };
    },
  });

  if (!isChefRayon) {
    return { isCentraleGT: false, centraleId: null, isLoading: false };
  }

  return {
    isCentraleGT: data?.isCentraleHQ ?? false,
    centraleId: data?.centraleId ?? null,
    isLoading,
  };
}
